export default "__VITE_ASSET__d334cdbf__"